import type { LiveStreamState } from '@/hooks/useChatStream';

const INITIAL_STATE: LiveStreamState = {
  isActive: false,
  isDone: false,
  isReasoning: false,
  phase: null,
  toolCalls: [],
  text: '',
};

const statesByChatId = new Map<string, LiveStreamState>();
const listenersByChatId = new Map<string, Set<() => void>>();

function emit(chatId: string) {
  const set = listenersByChatId.get(chatId);
  if (!set) return;
  for (const cb of set) cb();
}

export function getAgentChatStreamState(chatId: string): LiveStreamState {
  return statesByChatId.get(chatId) ?? INITIAL_STATE;
}

export function subscribeAgentChatStreamState(chatId: string, onChange: () => void): () => void {
  let set = listenersByChatId.get(chatId);
  if (!set) {
    set = new Set();
    listenersByChatId.set(chatId, set);
  }
  set.add(onChange);
  return () => {
    set!.delete(onChange);
    if (set!.size === 0) listenersByChatId.delete(chatId);
  };
}

export function updateAgentChatStreamState(
  chatId: string,
  updater: (prev: LiveStreamState) => LiveStreamState
): void {
  const prev = statesByChatId.get(chatId) ?? INITIAL_STATE;
  const next = updater(prev);
  if (next === prev) return;
  statesByChatId.set(chatId, next);
  emit(chatId);
}

export function resetAgentChatStreamState(chatId: string): void {
  if (!statesByChatId.has(chatId)) return;
  statesByChatId.delete(chatId);
  emit(chatId);
}

export function clearAgentChatStreamState(chatId: string): void {
  statesByChatId.delete(chatId);
  listenersByChatId.delete(chatId);
}
